module.exports = __webpack_public_path__ + "img/tags.92dc0235.svg";